// 1. Function to load the Razorpay SDK script dynamically
const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

// 2. Main Payment Handler
export const processPayment = async ({
  price,
  userData,
  bookingId,
  orderId,
  onSuccess,
  onFailure
}) => {
  const res = await loadRazorpayScript();

  if (!res) {
    alert("Razorpay SDK failed to load. Please check your internet connection.");
    if (onFailure) onFailure();
    return;
  }

  // RAZORPAY OPTIONS
  const options = {

    // key: "rzp_test_RhZZf4ulFchnrn",
    key: "rzp_live_SonWQa5jvUVndY",


    amount: price * 100,
    currency: "INR",
    order_id: orderId, // Added for backend order generation
    name: "World of Nabi",
    description: "Therapy Session Booking",
    image: "logo.png",

    // Notes injected for webhook processing
    notes: {
      bookingId: bookingId || ""
    },

    // Handler triggered ONLY upon successful payment
    handler: function (response) {
      // response.razorpay_payment_id contains the transaction ID
      onSuccess(response);
    },

    // Prefill user details so they don't have to type them again in the payment popup
    prefill: {
      name: userData.fullName || "",
      email: userData.email || "",
      contact: userData.contactNumber ? `+91${userData.contactNumber}` : "",
    },

    theme: {
      color: "#F07167",
    },

    // Handle when user closes the modal without paying
    modal: {
      ondismiss: function () {
        console.log("Payment modal closed");
        if (onFailure) onFailure("User dismissed payment modal");
      }
    }
  };

  const paymentObject = new window.Razorpay(options);
  paymentObject.open();
};